import React, { Component } from 'react';
import ViewHeader from '../../components/ViewHeader';
import ModuleContainer from '../../components/ModuleContainer';
import { FaPencilAlt, FaRegWindowClose, FaArrowLeft, FaTrashAlt } from 'react-icons/fa';
import { connect } from 'react-redux';
import { calendarSelector, calendarOperations } from './state';
import { bindActionCreators } from 'redux';
import FormTemplate from '../../components/FormTemplate';
import { Row } from 'react-bootstrap';
import {
    MODE_ADD, MODE_VIEW, MODE_EDIT, ERROR, SUCCESS, DATE_TIME_FORMAT, NOTIF_SUCCESS, NOTIF_ERROR, PRIMARY, SECONDARY, SUCCESS_BUTTON, SAVE,
    CANCEL, BACK, DANGER, DELETE, UPDATE, YES, NO, EVENT_DETAILS
} from '../../../utils/constants';
import { isNullOrUndefined } from 'util';
import { CALENDARS_ROUTE, VIEW_CALENDAR_ROUTE } from './routes';
import moment from 'moment';
import ConfirmationModal from '../../components/ConfirmationModal';
import { SideNotification } from '../../../utils/common';
import { MSG_DEFAULT_ERROR, MSG_CONFIRM_CHANGES, SAVE_CHANGES, DELETE_CALENDAR, DELETE_MESSAGE } from '../../../utils/messages';
import debounce from 'lodash.debounce';

class ViewCalendar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            imageFile: null,
            calendarId: 0,
            mode: MODE_ADD,
            initialCalendarDetails: null,
            imageHash: Date.now(),
            imageError: false,
            showSaveModal: false,
            showDeleteModal: false,
            calendarDetails: [],
            adsSearch: '',
            hasSubmit: false
        }

        //Required to make submission possible on external button
        this.calendarForm = null;
        this.resetForm = null;
        this.saveChanges = debounce(this.saveChanges.bind(this), 500);
        this.deleteCalendar = debounce(this.deleteCalendar.bind(this), 500);
    }


    componentDidMount() {

        let id = this.props.match.params.id;

        if (undefined === id) {
            this.setState({ mode: MODE_ADD })
        } else {
            let type = isNullOrUndefined(this.props.location.state) ? MODE_VIEW : this.props.location.state.type;

            this.setState({ calendarId: id, mode: type }, () => {
                this.props.getCalendarById(this.state.calendarId)
                    .then((response) => {
                        if (ERROR === response.status) {
                            SideNotification(NOTIF_ERROR, response.message)
                            this.props.history.push(CALENDARS_ROUTE);
                        } else {
                            let calendar = response.data;
                            calendar.startDate = moment(calendar.startDateTime).format(DATE_TIME_FORMAT);
                            calendar.endDate = moment(calendar.endDateTime).format(DATE_TIME_FORMAT);
                            calendar.isOfficer = 1 === calendar.isOfficer;
                            this.setState({ initialCalendarDetails: { CalendarModel: response.data } })
                        }
                    })
                    .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
            })
        }
    }



    isViewMode = () => {
        return MODE_VIEW === this.state.mode;
    }


    handleSubmit = (values) => {

        let newCalendar = values.CalendarModel;
        newCalendar.startDateTime = moment(newCalendar.startDate);
        newCalendar.endDateTime = moment(newCalendar.endDate);


        this.setState({ calendarDetails: values }, () => this.toggleSave());

    }

    toggleSave = () => {
        this.setState(prevState => ({ showSaveModal: !prevState.showSaveModal }));
    }

    saveChanges = () => {

        let values = Object.assign({}, this.state.calendarDetails)
        if (MODE_EDIT === this.state.mode) {
            this.props.updateCalendar(values.CalendarModel)
                .then(result => {
                    if (SUCCESS === result.status) {
                        this.setState({ mode: MODE_VIEW, showSaveModal: false, initialCalendarDetails: { CalendarModel: values.CalendarModel } })
                        SideNotification(NOTIF_SUCCESS, result.message);
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        } else {
            this.props.insertCalendar(values.CalendarModel)
                .then(result => {
                    if (SUCCESS === result.status) {
                        SideNotification(NOTIF_SUCCESS, result.message);
                        this.props.history.push({ pathname: VIEW_CALENDAR_ROUTE + `/${result.data}`, state: { type: MODE_VIEW } });
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        }
    }



    bindSubmitFormik = (submitForm, resetForm) => {
        this.submitForm = submitForm;
        this.resetForm = resetForm;
    };

    updateFormRef = (newForm) => {
        this.form = newForm;
    }

    onSubmitClick = () => {
        this.setState({ hasSubmit: true })
        this.form.submitForm();
    }

    onCancelClick = () => {
        
        if (!isNullOrUndefined(this.state.initialCalendarDetails)) {
            this.form.resetForm(this.state.initialCalendarDetails);
        }

        this.updateMode(MODE_VIEW);
    }

    updateMode = (mode) => {
        if (null !== this.state.initialCalendarDetails) {
            this.setState({ mode });
        }
    }

    toggleDelete = () => {
        this.setState(prevState => ({ showDeleteModal: !prevState.showDeleteModal }))

    }

    deleteCalendar = () => {
        this.props.deleteCalendar(this.state.calendarId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.props.history.push(CALENDARS_ROUTE);
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.toggleDelete();
            });
    }


    renderRightButtons = () => {
        switch (this.state.mode) {
            case MODE_ADD: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: () => this.props.history.push(CALENDARS_ROUTE) },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick },
                ]
            }
            case MODE_EDIT: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.onCancelClick },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick },
                ]
            }
            default: {
                return [
                    { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(CALENDARS_ROUTE) },
                    { variant: PRIMARY, label: UPDATE, icon: FaPencilAlt, onClick: () => this.updateMode(MODE_EDIT) },
                    { variant: DANGER, label: DELETE, icon: FaTrashAlt, onClick: this.toggleDelete }
                ]
            }
        }
    }

    render() {
        return (
            <ModuleContainer>
                <ViewHeader
                    title={EVENT_DETAILS}
                    rightButtons={this.renderRightButtons()}
                />
                <Row style={{ paddingTop: '30px' }}>

                    <FormTemplate
                        editMode={MODE_ADD !== this.state.mode}
                        readOnly={MODE_VIEW === this.state.mode}
                        initialValues={this.state.initialCalendarDetails}
                        bindSubmitFormik={this.bindSubmitFormik}
                        formInputs={this.props.calendarForm}
                        validate={calendarSelector.validateForm}
                        updateFormRef={this.updateFormRef}
                        handleSubmit={this.handleSubmit}
                        hasSubmit={this.state.hasSubmit}
                    />
                </Row>
                <ConfirmationModal
                    show={this.state.showSaveModal}
                    toggleModal={this.toggleSave}
                    title={SAVE_CHANGES}
                    message={MSG_CONFIRM_CHANGES}
                    modalButtons={[
                        { label: NO, onClick: this.toggleSave, variant: SECONDARY },
                        { label: YES, onClick: this.saveChanges, variant: SUCCESS_BUTTON }
                    ]}
                />

                <ConfirmationModal
                    show={this.state.showDeleteModal}
                    toggleModal={this.toggleDelete}
                    title={DELETE_CALENDAR}
                    message={DELETE_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.toggleDelete, variant: SECONDARY },
                        { label: YES, onClick: this.deleteCalendar, variant: DANGER }
                    ]}
                />


            </ModuleContainer>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        calendarForm: state.calendars.calendarForm,
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        insertCalendar: calendarOperations.insertCalendar,
        getCalendarById: calendarOperations.getCalendarById,
        deleteCalendar: calendarOperations.deleteCalendar,
        updateCalendar: calendarOperations.updateCalendar
    },
    dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(ViewCalendar);